import React, { useRef, useEffect } from 'react';
import SmoothScrollbar from 'smooth-scrollbar';

import { updateGlobals, EVENTS } from '../helpers/globals';
import './../styles/smooth-scroll.scss';

const options = {
  damping: 0.03,
  thumbMinSize: 10,
  renderByPixels: true,
  alwaysShowTracks: false,
  continuousScrolling: true,
  delegateTo: null,
  plugins: {},
}

const MomentumScroll: React.FC<any> = ({ children, onScroll }) => {
  const scrollbarRef = useRef(null);
  const containerRef = useRef(null);
  const eventRef = useRef(null);
  const onScrollRef = useRef(null);

  const handleScroll = (status) => {
    if (onScroll) {
      onScroll(status, scrollbarRef.current);
    }
    if (typeof window !== 'undefined') {
      const event = new CustomEvent(EVENTS.onPageScroll, {
        detail: status
      });
      window.dispatchEvent(event);
    }
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      eventRef.current = new Event(EVENTS.onSmoothScrollInit);
      // onScrollRef.current = new CustomEvent(EVENTS.onPageScroll);
    }

    scrollbarRef.current = SmoothScrollbar.init(containerRef.current, options);
    scrollbarRef.current.addListener(handleScroll);

    updateGlobals('SMOOTH_SCROLL_CONTEXT', scrollbarRef.current);
    setTimeout(() => {
      window.dispatchEvent(eventRef.current);
    }, 10);

    return () => {
      scrollbarRef.current.destroy();
      updateGlobals('SMOOTH_SCROLL_CONTEXT', '');
      eventRef.current = null;
      onScrollRef.current = null;
    };
  }, []);

  return (
    <div data-scrollbar id="hp-momentum-scroll" className="hp-momentum-scroll" ref={containerRef}>
      {children}
    </div>
  );
};

export default MomentumScroll;
